/// <amd-module name="Release/Landing/HubContent/Releases/ActiveReleasesMenuCommands" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";
import { IMenuItem } from "VSSUI/Menu";

import { Release, ReleaseStatus } from "Release/Client/Contracts/Release";
import { IReleaseMenuCommandContext, IReleaseDefinitionPivotCommandContext, IStartReleaseCommandContext } from "Release/Client/ExtensionContracts/IMenuCommandContracts";
import { abandonReleaseCommand, viewReleaseCommand, deleteReleaseCommand, undeleteReleaseCommand, changeRetentionCommand } from "Release/Commands/ReleaseCommandsService";
import { startReleaseCommand } from "Release/Commands/CreateReleaseCommandService";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { MessageActions } from "Release/Landing/HubMessageBar/MessageActions";
import { ActiveReleasesActionCreator } from "./ActiveReleasesActionCreator";
import { ActiveReleasesActions, IActiveReleasesPayload } from "./ActiveReleasesActions";
import { MessageBarKeys } from "Release/Landing/Constants";

export class ActiveReleasesMenuCommands {

    constructor() {
        this._messageActions = ActionsHubManager.GetActionsHub<MessageActions>(MessageActions);
        this._activeReleasesActions = ActionsHubManager.GetActionsHub<ActiveReleasesActions>(ActiveReleasesActions);
        this._activeReleasesActionCreator = ActionCreatorManager.GetActionCreator<ActiveReleasesActionCreator>(ActiveReleasesActionCreator);
    }

    public getCommands(pageContext: IVssPageContext, release: Release, isDeleted: boolean): IMenuItem[] {
        const menuItems: IMenuItem[] = [];
        let context: IReleaseMenuCommandContext = {
            pageContext: pageContext,
            release: release,
            telemetrySource: this.TelemetrySource,
            errorCallback: (message: React.ReactNode) => {
                this._messageActions.setMessage.invoke({ key: MessageBarKeys.HubError, value: message });
            }
        } as IReleaseMenuCommandContext;

        let command;
        if (isDeleted) {
            let undeleteContext = context;
            command = undeleteReleaseCommand(undeleteContext);
            undeleteContext.successCallback = (message: React.ReactNode) => {
                this._activeReleasesActions.removeRelease.invoke({
                    releaseId: release.id
                });
                this._messageActions.setMessage.invoke({ key: MessageBarKeys.HubSuccess, value: message });
            };
            if (command) {
                menuItems.push(command);
            }
        }
        else {
            context.successCallback = (message: React.ReactNode) => { };
            command = viewReleaseCommand(context);
            if (command) {
                menuItems.push(command);
            }

            const startReleaseCommandContext = {
                pageContext: pageContext,
                pipelineId: release.releaseDefinition.id,
                pipelineName: release.releaseDefinition.name,
                isFolder: false,
                releaseId: release.id,
                folderPath: release.releaseDefinition.path,
                successCallback: (message: React.ReactNode, isDeletion: boolean, updatedRelease: Release) => {
                    this._activeReleasesActions.updateRelease.invoke({ release: updatedRelease });
                    this._messageActions.setMessage.invoke({ key: MessageBarKeys.HubSuccess, value: message });
                },
                errorCallback: (message: React.ReactNode) => {
                    this._messageActions.setMessage.invoke({ key: MessageBarKeys.HubError, value: message });
                }
            } as IStartReleaseCommandContext;
            command = startReleaseCommand(startReleaseCommandContext);
            if (command) {
                command.disabled = !(release.status === ReleaseStatus.Draft);
                menuItems.push(command);
            }

            let updateReleaseContext = { ...context };
            updateReleaseContext.successCallback = (message: React.ReactNode, isDeletion: boolean, updatedRelease: Release) => {
                this._activeReleasesActions.updateRelease.invoke({ release: updatedRelease });
                this._messageActions.setMessage.invoke({ key: MessageBarKeys.HubSuccess, value: message });
            };
            command = changeRetentionCommand(updateReleaseContext);
            if (command) {
                menuItems.push(command);
            }

            command = abandonReleaseCommand(updateReleaseContext);
            if (command) {
                command.disabled = (release.status === ReleaseStatus.Abandoned);
                menuItems.push(command);
            }

            let deleteReleaseContext = { ...context };
            deleteReleaseContext.successCallback = (message: React.ReactNode) => {
                this._activeReleasesActions.removeRelease.invoke({
                    releaseId: release.id
                });
                this._messageActions.setMessage.invoke({ key: MessageBarKeys.HubSuccess, value: message });
            };
            command = deleteReleaseCommand(deleteReleaseContext);
            if (command) {
                menuItems.push(command);
            }
        }

        return menuItems;
    }

    private _activeReleasesActions: ActiveReleasesActions;
    private _activeReleasesActionCreator: ActiveReleasesActionCreator
    private _messageActions: MessageActions;
    private readonly TelemetrySource = "ReleaseLWPLanding";
}